import { Component, OnInit } from '@angular/core';
import { ChartConfiguration } from 'chart.js';

@Component({
  selector: 'app-emotionalanalysis',
  templateUrl: './emotionalanalysis.component.html',
  styleUrl: './emotionalanalysis.component.scss',
})
export class EmotionalanalysisComponent implements OnInit {
  emotions: Array<any> = [];

  // Emotional Analysis Chart
  public emotionAnalysislables: string[] = [
    '00:00:02',
    '00:00:04',
    '00:00:06',
    '00:00:08',
    '00:00:10',
    '00:00:12',
    '00:00:14',
    '00:00:16',
    '00:00:18',
    '00:00:20',
    '00:00:22',
    '00:00:24',
    '00:00:26',
    '00:00:28',
    '00:00:30',
    '00:00:32',
    '00:00:34',
    '00:00:36',
    '00:00:38',
    '00:00:40',
    '00:00:42',
    '00:00:44',
    '00:00:46',
    '00:00:48',
    '00:00:50',
  ];

  public emotionAnalysislegend = true;

  public emotionAnalysisoptions: ChartConfiguration<'line'>['options'] = {
    responsive: true,
    scales: {
      x: { title: { display: true, text: 'Video Timeline' } },
      y: { title: { display: true, text: 'Emotions' } },
    },
  };

  public emotionAnalysisdataSets: ChartConfiguration<'line'>['data']['datasets'] =
    [
      {
        label: 'Ambiguity',
        data: [
          0, 0, 0, 0.1, 0.15, 0.2, 0.25, 0.1, 0.1, 0.15, 0.15, 0.15, 0.7, 0.7,
          0.7, 0.3, 0.2, 0.1, 0, 0.1, 0.15, 0.2, 0.25, 0.2, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(255, 127, 0, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Angry',
        data: [
          0, 0.5, 0.7, 0.8, 0.7, 0.9, 1, 1.3, 1.2, 1.1, 0.7, 0.9, 1, 1.3, 1.5,
          0.7, 1, 0.8, 0.7, 0.5, 1, 0.2, 0.3, 0.2, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(227, 26, 28, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Fearful',
        data: [
          0, 0.1, 0.15, 0.2, 0, 0.05, 0.1, 0.15, 0.6, 0.8, 1, 0.9, 0.8, 0.6, 0,
          0.1, 0.35, 0.1, 0.15, 0.2, 0.7, 1, 0.5, 0.3, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(251, 154, 153, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Disgusted',
        data: [
          0, 0.15, 0.2, 0.9, 1, 0.6, 0.8, 1, 1.2, 1.4, 2, 1.3, 1.2, 1, 0.9, 0.1,
          0, 1.2, 1, 0.9, 0.6, 1.2, 0.9, 0.4, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(253, 191, 111, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Happy',
        data: [
          0, 0.2, 0.25, 0.7, 0.3, 1.8, 0.7, 1.9, 1.2, 2.1, 2.2, 3.1, 1.1, 1,
          0.7, 0.7, 1.9, 1.7, 2.1, 1.8, 1.7, 1.2, 0, 0.4, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(0, 209, 189, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Neutral',
        data: [
          0, 0, 0, 1, 1.1, 2.2, 2.2, 1.9, 3.6, 1.9, 2.1, 2.2, 3.7, 2.5, 2.4,
          1.7, 1.7, 3.5, 2.3, 2.2, 0, 1, 1.1, 1.8, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(0, 168, 186, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Sad',
        data: [
          0, 0.8, 0.9, 1.4, 1.6, 2.2, 0.1, 0, 3.1, 0.9, 0.8, 3.9, 2, 2, 4.6, 0,
          3.9, 3.1, 3, 2.2, 1.8, 1.7, 0, 1, 0.7, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(31, 120, 180, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Surprised',
        data: [
          0, 0, 0, 1.7, 1.9, 3.6, 1.8, 3.6, 0.9, 2.6, 2.6, 4.5, 4.6, 5.4, 1.8,
          2.4, 2.5, 3.6, 1.8, 1.8, 1.8, 0.9, 0.9, 0.5, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(166, 206, 227, 0.8)',
        pointRadius: 0,
      },
      // END Emotional Analysis Chart
    ];

  ngOnInit(): void {
    this.emotions = [
      { imgUrl: 'assets/images/thinking.svg', name: 'Ambiguity', per: 10 },
      { imgUrl: 'assets/images/angry.svg', name: 'Angry', per: 2 },
      { imgUrl: 'assets/images/crying.svg', name: 'Disgusted', per: 2 },
      { imgUrl: 'assets/images/scared.svg', name: 'Fearful', per: 0 },
      { imgUrl: 'assets/images/happy.svg', name: 'Happy', per: 4 },
      { imgUrl: 'assets/images/neutral.svg', name: 'Neutral', per: 0 },
      { imgUrl: 'assets/images/sad.svg', name: 'Sad', per: 0 },
      { imgUrl: 'assets/images/surprised.svg', name: 'Surprised', per: 0 },
    ];
  }
}
